// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__neutra2Text_1cd59b', '__neutra2Text_Fallback_1cd59b', Geneva, Verdana, sans-serif"},"className":"__className_1cd59b"};